const BEST_SCORE_KEY = 'flappy-stick-bird:best-score';

export class ScoreManager {
  private score = 0;
  private bestScore = Number(localStorage.getItem(BEST_SCORE_KEY) ?? 0);

  reset(): void {
    this.score = 0;
  }

  addPoint(): number {
    this.score += 1;

    if (this.score > this.bestScore) {
      this.bestScore = this.score;
      localStorage.setItem(BEST_SCORE_KEY, String(this.bestScore));
    }

    return this.score;
  }

  getScore(): number {
    return this.score;
  }

  getBestScore(): number {
    return this.bestScore;
  }
}
